// extracted by mini-css-extract-plugin
export default {"setting_arrow":"Setting_setting_arrow__d3qbL","active_language":"Setting_active_language__r1AsI"};